import { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import { apiFetch } from "./shared";

export const SaveJobButton = ({ jobId }) => {
    const [authed, setAuthed] = useState(false);
    const [saved, setSaved] = useState(false);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const me = await apiFetch("/candidate/me");
                if (!me.ok) return;
                setAuthed(true);
                const res = await apiFetch("/candidate/saved-jobs");
                if (res.ok) {
                    const jobs = await res.json();
                    setSaved(jobs.some((j) => j.id === jobId));
                }
            } catch {}
        })();
    }, [jobId]);

    const toggle = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!authed) {
            window.location.href = "/account/login";
            return;
        }
        if (busy) return;
        setBusy(true);
        try {
            if (saved) {
                await apiFetch(`/candidate/saved-jobs/${jobId}`, { method: "DELETE" });
                setSaved(false);
            } else {
                await apiFetch("/candidate/saved-jobs", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ job_id: jobId }),
                });
                setSaved(true);
            }
        } finally {
            setBusy(false);
        }
    };

    return (
        <button
            type="button"
            data-testid={`save-job-${jobId}`}
            onClick={toggle}
            disabled={busy}
            aria-label={saved ? "Remove saved job" : "Save job"}
            className={`inline-flex items-center gap-2 border px-4 py-3 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
                saved
                    ? "border-champagne/60 text-[#8a7320]"
                    : "border-ink/15 text-ink/50 hover:border-champagne/60 hover:text-[#8a7320]"
            }`}
        >
            <Bookmark size={14} strokeWidth={1.5} fill={saved ? "currentColor" : "none"} />
            {saved ? "Saved" : "Save"}
        </button>
    );
};
